export default __webpack_public_path__ + "static/email-ead522214b9ed8794a2b378ee0d030b8.jpg";